import { AgentDocumentComponent } from './agent-document/agent-document.component';
import { AgentService } from './services/agent.service';
import { AgentStepFormComponent } from './agent-step-form/agent-step-form.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SystemCommonModule } from './../system-common/system-common.module';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AgentRoutingModule } from './agent-routing.module';
import { AgentPartyIdentityComponent } from './agent-party-identity/agent-party-identity.component';
import { AgentPartyDetailsComponent } from './agent-party-details/agent-party-details.component';
import { AgentPartyAddressComponent } from './agent-party-address/agent-party-address.component';
import { AgentPartyAddressTabsComponent } from './agent-party-address-tabs/agent-party-address-tabs.component';
import { AgentPartyContactComponent } from './agent-party-contact/agent-party-contact.component';
import { AgentDocumentImageComponent } from './agent-document-image/agent-document-image.component';
import { AgentPaymentComponent } from './agent-payment/agent-payment.component';
import { AgentPartyEducationComponent } from './agent-party-education/agent-party-education.component';
import { AgentTrainingComponent } from './agent-training/agent-training.component';
import { AgentExamComponent } from './agent-exam/agent-exam.component';
import { AgentSearchComponent } from './agent-search/agent-search.component';
import { AgentSignatureComponent } from './agent-signature/agent-signature.component';
import { AgentReviewApplicationComponent } from './agent-review-application/agent-review-application.component';
import { AgentProfileComponent } from './agent-profile/agent-profile.component';
import { AgentCheckerSearchComponent } from './agent-checker-search/agent-checker-search.component';
import { AgentPaymentViewComponent } from './agent-payment-view/agent-payment-view.component';
import { AgentReviewStepFormComponent } from './agent-review-step-form/agent-review-step-form.component';
import { AgentRejectViewComponent } from './agent-reject-view/agent-reject-view.component';
import { AgentTransferToApplicantComponent } from './agent-transfer-to-applicant/agent-transfer-to-applicant.component';
import { AgentAddNoteComponent } from './agent-add-note/agent-add-note.component';
import { AgentAuditSearchComponent } from './agent-audit-search/agent-audit-search.component';
import { AgentExistingInsuranceAgencyDetailsComponent } from './agent-existing-insurance-agency-details/agent-existing-insurance-agency-details.component';
import { AgentNomineeComponent } from './agent-nominee/agent-nominee.component';
import { AgentHierarchyDetailsComponent } from './agent-hierarchy-details/agent-hierarchy-details.component';
import { AgentHierarchySearchComponent } from './agent-hierarchy-search/agent-hierarchy-search.component';
import { AgentHierarchySupervisorComponent } from './agent-hierarchy-supervisor/agent-hierarchy-supervisor.component';
import { AgentHierarchyBranchSearchComponent } from './agent-hierarchy-branch-search/agent-hierarchy-branch-search.component';
import { AgentHierarchyBranchComponent } from './agent-hierarchy-branch/agent-hierarchy-branch.component';
import { AgentBankBranchComponent } from './agent-bank-branch/agent-bank-branch.component';
import { AgentBankBranchSearchComponent } from './agent-bank-branch-search/agent-bank-branch-search.component';
import { AgentRecruitmentStepFormComponent } from './agent-recruitment-step-form/agent-recruitment-step-form.component';
import { AgentQuestionComponent } from './agent-question/agent-question.component';
import { AgentFamilyComponent } from './agent-family/agent-family.component';
import { AgentReferenceComponent } from './agent-reference/agent-reference.component';

@NgModule({
  declarations: [
    //SearchProductionDetailsComponent,
    AgentBankBranchSearchComponent,
    AgentBankBranchComponent,
    AgentHierarchyBranchComponent,
    AgentHierarchySupervisorComponent,
    AgentSearchComponent,
    AgentHierarchySearchComponent,
    AgentHierarchyBranchSearchComponent,
    AgentStepFormComponent,
    AgentRecruitmentStepFormComponent,
    AgentProfileComponent,
    AgentPartyIdentityComponent,
    AgentPartyDetailsComponent,
    AgentPartyAddressComponent,
    AgentPartyAddressTabsComponent,
    AgentPartyContactComponent,
    AgentDocumentComponent,
    AgentDocumentImageComponent,
    AgentPaymentComponent,
    AgentPartyEducationComponent,
    AgentTrainingComponent,
    AgentExamComponent,
    AgentSignatureComponent,
    AgentReviewApplicationComponent,
    AgentExistingInsuranceAgencyDetailsComponent,
    AgentNomineeComponent,
    AgentHierarchyDetailsComponent,
    AgentCheckerSearchComponent,
    AgentPaymentViewComponent,
    AgentReviewStepFormComponent,
    // AgentReviewApplicationPdfViewComponent,
    AgentAddNoteComponent,
    AgentAuditSearchComponent,
    AgentRejectViewComponent,
    AgentTransferToApplicantComponent,
    AgentQuestionComponent,
    AgentFamilyComponent,
    AgentReferenceComponent,
  ],
  imports: [CommonModule, FormsModule, SystemCommonModule, AgentRoutingModule, ModalModule.forRoot()],
  providers: [AgentService],
  exports: [AgentHierarchySupervisorComponent, AgentHierarchyBranchComponent],
})
export class AgentModule {}
